import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './HeroBanner.css';

class HeroBanner extends Component {
  render() {
    return (
      <section className="hero-banner-section container py-4">
        <div className="hero-banner-card d-flex align-items-center">
          
          {/* Left Content Column */}
          <div className="hero-content px-4 px-md-5 py-5">
            <h1 className="hero-title text-white mb-3">
              Find The Perfect <br /> Stay For Every <br /> Journey
            </h1>
            <p className="hero-subtitle m-0">
              Book verified stays across Bangladesh, instantly.
            </p>
          </div>

        </div>
      </section>
    );
  }
}

export default HeroBanner;
